// extracted by mini-css-extract-plugin
module.exports = {"Wrapper":"Ratings_Wrapper__1h3vB","Rating":"Ratings_Rating__2Exeh","Star":"Ratings_Star__1F_pz"};